// src/App.js
import React, { useState, useEffect, useCallback, useRef } from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
  useNavigate,
  Navigate,
  useLocation,
  useParams,
} from 'react-router-dom';

import Login from './components/Login';
import Register from './components/Register';
import PostList from './components/PostList';
import PostListAdmin from './components/Useradmin';
import PostForm from './components/PostForm';
import ProfilePost from './components/ProfilePost';
import PostlistGuest from './components/Userguest';
import MyProfilePages from './components/MyProfile';
import About from './components/Aboutus';
import Reallybot from './Logo/Reallybot.png'; // Adjust path if needed
import { m, useIsomorphicLayoutEffect } from 'framer-motion';
import PostDetail from './components/Postdetails'; // import the new component
import ArticleDetail from './components/ArticleDetail';
import BlogDetail from './components/BlogDetail';
import BlogBoard from './components/BlogBoard';
import LearningQABoard from './components/LearningQABoard';
import HiringDetail from './components/HiringDetail';
import LookingForJobDetail from './components/LookingForJobDetail';
import LookingForJobBoard from './components/LookingForJobBoard';
import EmployerApplications from './components/EmployerApplications';
import MyApplications from './components/MyApplications';
import SavedPage from './components/SavedPage';
import { endAuthSession, clearAuthToken, AUTH_EXPIRED_EVENT } from './utils/authToken';
import MyLearningDashboard from './components/MyLearningDashboard';
import ProfileViewsInbox from './components/ProfileViewsInbox';
import PublicPostDetail from './components/PublicPostDetail';
import HomeUser from './components/userhome';
import GroupDashboard from './components/groups/Grouptab'
import GroupPosts from './components/groups/GroupPosts';
import PublicGroupPage from './components/groups/PublicGroupPage'; // adjust path
import UserProfile from './components/UserProfile'
import MyNetwork from './components/MyNetwork'
import MessagingDock from './components/MessagingDock'
import PublicGroupPageview from './components/groups/PublicGroupview'
import PublicGroupPageview2 from './components/groups/Groupforpublicview.js'
import Guestheader from './components/headers/guestheader'
import AuthenticatedNavbar from './components/headers/AuthenticatedNavbar'
import NewsDetails from "./components/whatisnew/NewsDetails"; // new page
import NewsListPage from "./components/NewsListPage";
import AllPublicGroupsPage from "./components/groups/AllPublicGroups"
import GroupsHubPage from "./components/GroupsHubPage"
import EventDetails from "./components/addCoolactivities/EventDetails.js"
import EventDetailslist from "./components/addCoolactivities/AlleventlistGuest.js"
import Evenlistalls from "./components/addCoolactivities/Alleventlist.js"
import EventAttendanceList from "./components/eventAttendance/EventAttendanceList.js"
import EventAttendanceDetails from "./components/eventAttendance/EventAttendanceDetails.js"
import UserManagementPage  from "./components/admin/UserManager.js"
import HiringManagementPage from "./components/admin/HiringManagement.js"
import Dashboard from './components/admin/AnalyticsDashboard.js'
import ReportsQueue from './components/admin/ReportsQueue';
import AssistantCalibratePage from './components/admin/AssistantCalibrate.js'
import GroupsManagementPage from './components/admin/GroupsManagement.js'
import CoolAssistantWidget from './components/CoolAssistantWidget'
import SurveyPanel from './components/survey/SurveyPanel'
import HashtagPage from './components/HashtagPage'
import { getApiBaseUrl } from './config/api'
import { isAdmin } from './utils/userRole'
import useLiveRefresh from './hooks/useLiveRefresh'
import { mergeFeedPosts, isFeedNearTop } from './utils/mergeFeedPosts'

const API_URL = getApiBaseUrl();

function SurveyStandalonePage({ user, onLogout }) {
  const { surveyId } = useParams();
  return (
    <div style={{ width: '100%', minHeight: '100vh', background: '#f8fafc' }}>
      {user ? (
        <AuthenticatedNavbar user={user} onLogout={onLogout} />
      ) : (
        <div
          style={{
            position: 'sticky',
            top: 0,
            zIndex: 1000,
            backgroundColor: '#fff',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          }}
        >
          <Guestheader />
        </div>
      )}
      <div style={{ maxWidth: 960, margin: '0 auto', padding: 16 }}>
        <SurveyPanel user={user} surveyId={surveyId || null} page="main" />
      </div>
    </div>
  );
}





function AppWrapper() {
  
  return (
   <BrowserRouter>
      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <MainApp />
      </div>
 </BrowserRouter>
  );
}

function MainApp() {
  const navigate = useNavigate();
  const location = useLocation();

  // ✅ User state, loaded from localStorage on initial render
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem('forumUser') || localStorage.getItem('user');
    return savedUser ? JSON.parse(savedUser) : null;
  });

  const recordPageView = useCallback(
    async (page) => {
      if (!API_URL || !page) return;
      try {
        await fetch(`${API_URL}/record_page_view.php`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams({
            page,
            user_id: user?.id || 0,
          }),
        });
      } catch (err) {
        // Silently ignore tracking failures so they don't spam the console
        // This avoids "TypeError: Failed to fetch" errors when the API is offline.
      }
    },
    [user?.id]
  );

  // Optional: keep user updated if localStorage changes
  useEffect(() => {
    const savedUser = localStorage.getItem('forumUser') || localStorage.getItem('user');
    if (savedUser) setUser(JSON.parse(savedUser));
  }, []);

  useEffect(() => {
    const onClick = (event) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }
      const anchor = event.target.closest?.('a[href^="/hashtag/"]');
      if (!anchor || anchor.target === '_blank') return;
      const href = anchor.getAttribute('href');
      if (!href) return;
      event.preventDefault();
      navigate(href);
    };
    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
  }, [navigate]);

  const [posts, setPosts] = useState([]);
  const [likes, setLikes] = useState({});
  const [userLiked, setUserLiked] = useState({});
  const [feedFilter, setFeedFilter] = useState('all');
  const [feedHasMore, setFeedHasMore] = useState(false);
  const [feedOffset, setFeedOffset] = useState(0);
  const [feedLoading, setFeedLoading] = useState(false);
  const [pendingNewCount, setPendingNewCount] = useState(0);
  const pendingNewRef = useRef([]);
  const FEED_PAGE_SIZE = 20;

  const refreshPosts = useCallback(async (feedOverride, options = {}) => {
    if (!API_URL) {
      console.error('REACT_APP_API_URL is not configured');
      return;
    }

    const feed = feedOverride || feedFilter || 'all';
    const paged = options.paged === true;
    const append = options.append === true;
    const merge = options.merge === true;
    const silent = options.silent === true;
    const offset = append ? (options.offset ?? 0) : 0;

    if (paged && !silent) {
      setFeedLoading(true);
    }

    try {
      const params = new URLSearchParams();
      const viewerId = user?.id;
      if (feed && feed !== 'all') {
        params.set('feed', feed);
      }
      if (viewerId) {
        params.set('viewer_id', String(viewerId));
      }
      if (paged) {
        params.set('limit', String(FEED_PAGE_SIZE));
        params.set('offset', String(offset));
      }
      const qs = params.toString();
      const url = `${API_URL}/get_posts.php${qs ? `?${qs}` : ''}`;
      const res = await fetch(url);
      if (!res.ok) {
        throw new Error(`GET ${API_URL}/get_posts.php failed with ${res.status}`);
      }

      const data = await res.json();
      if (data.success) {
        const incoming = data.posts || [];
        if (append) {
          setPosts((prev) => {
            const seen = new Set(prev.map((p) => p.id));
            const merged = [...prev];
            incoming.forEach((post) => {
              if (!seen.has(post.id)) {
                merged.push(post);
                seen.add(post.id);
              }
            });
            return merged;
          });
        } else if (merge) {
          const shouldPrepend =
            options.prependNew === 'if-near-top'
              ? isFeedNearTop()
              : options.prependNew !== false;
          const pendingToFlush = shouldPrepend ? pendingNewRef.current : [];
          if (shouldPrepend) {
            pendingNewRef.current = [];
          }
          let mergeResult = { heldNew: [], prepended: [], changed: false, posts: incoming };
          setPosts((prev) => {
            const seen = new Set(prev.map((post) => String(post.id)));
            const extra = pendingToFlush.filter((post) => !seen.has(String(post.id)));
            const base = extra.length ? [...extra, ...prev] : prev;
            mergeResult = mergeFeedPosts(base, incoming, { prependNew: shouldPrepend });
            return mergeResult.changed ? mergeResult.posts : base;
          });
          if (mergeResult.heldNew.length) {
            const pendingMap = new Map(
              pendingNewRef.current.map((post) => [String(post.id), post])
            );
            mergeResult.heldNew.forEach((post) => pendingMap.set(String(post.id), post));
            pendingNewRef.current = Array.from(pendingMap.values());
          }
          if (mergeResult.prepended.length) {
            const shown = new Set(mergeResult.prepended.map((post) => String(post.id)));
            pendingNewRef.current = pendingNewRef.current.filter(
              (post) => !shown.has(String(post.id))
            );
          }
          setPendingNewCount(pendingNewRef.current.length);
        } else {
          pendingNewRef.current = [];
          setPendingNewCount(0);
          setPosts(incoming);
        }
        if (paged && append) {
          setFeedOffset(typeof data.next_offset === 'number' ? data.next_offset : offset + incoming.length);
          setFeedHasMore(Boolean(data.has_more));
        } else if (paged && !merge && !silent) {
          setFeedOffset(typeof data.next_offset === 'number' ? data.next_offset : incoming.length);
          setFeedHasMore(Boolean(data.has_more));
        } else if (!paged) {
          setFeedOffset(incoming.length);
          setFeedHasMore(false);
        }
      } else {
        console.error('Backend error:', data.message);
      }
    } catch (err) {
      console.error('Failed to load posts:', err);
    } finally {
      if (paged && !silent) {
        setFeedLoading(false);
      }
    }
  }, [feedFilter, user?.id]);

  const refreshHomeFeed = useCallback(() => {
    return refreshPosts(undefined, { paged: true, merge: true, prependNew: true });
  }, [refreshPosts]);

  const applyPendingNewPosts = useCallback(() => {
    const toAdd = pendingNewRef.current;
    pendingNewRef.current = [];
    setPendingNewCount(0);
    if (!toAdd.length) return;
    setPosts((prev) => {
      const seen = new Set(prev.map((post) => String(post.id)));
      const unique = toAdd.filter((post) => !seen.has(String(post.id)));
      return unique.length ? [...unique, ...prev] : prev;
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const loadMorePosts = useCallback(async () => {
    if (!user?.id || feedLoading || !feedHasMore) {
      return;
    }
    return refreshPosts(undefined, { paged: true, append: true, offset: feedOffset });
  }, [refreshPosts, user?.id, feedLoading, feedHasMore, feedOffset]);

  const handleFeedFilterChange = useCallback((nextFeed) => {
    pendingNewRef.current = [];
    setPendingNewCount(0);
    setFeedFilter(nextFeed);
    setFeedHasMore(false);
    setFeedOffset(0);
    refreshPosts(nextFeed, { paged: true });
  }, [refreshPosts]);

  useEffect(() => {
    if (user?.id) {
      refreshPosts(undefined, { paged: true });
    } else {
      refreshPosts();
    }
  }, [user?.id]);

  const isHomeFeed = location.pathname === '/home' || location.pathname === '/home/';
  useLiveRefresh(
    () =>
      refreshPosts(undefined, {
        paged: true,
        merge: true,
        silent: true,
        prependNew: 'if-near-top',
      }),
    10000,
    Boolean(user?.id) && isHomeFeed
  );

  useEffect(() => {
    const pageUrl = `${location.pathname}${location.search}`;
    recordPageView(pageUrl);
  }, [location.pathname, location.search, recordPageView]);

  useEffect(() => {
    if (user?.role === 'admin' && window.location.pathname === '/') {
      navigate('/admin');
    }
  }, [user, navigate]);

  useEffect(() => {
    if (!user?.id) return;

    const fetchLikes = async () => {
      try {
        const res = await fetch(
          `${API_URL}/get_likes.php?user_id=${user.id}`
        );
        const data = await res.json();
        if (data.success) {
          setLikes(data.total_likes || {});
          setUserLiked(data.user_liked || {});
        } else {
          console.warn('Failed to load like data');
        }
      } catch (err) {
        console.error('Error fetching likes:', err.message);
      }
    };

    fetchLikes();
  }, [user?.id, posts]);

  const handleLike = async (targetId, type = 'post') => {
    if (!user?.id) {
      alert('Please login to like');
      return;
    }
    const key = `${type}_${targetId}`;
    const liked = userLiked[key];
    const url = liked ? 'unlike.php' : 'like.php';

    try {
      const res = await fetch(`${API_URL}/${url}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          user_id: user.id,
          target_id: targetId,
          target_type: type,
        }),
      });
      const data = await res.json();

      if (data.success) {
        setLikes((prev) => ({
          ...prev,
          [key]: liked ? Math.max(0, (prev[key] || 1) - 1) : (prev[key] || 0) + 1,
        }));

        setUserLiked((prev) => ({
          ...prev,
          [key]: !liked,
        }));
        // Likes/unlikes are logged server-side in like.php / unlike.php
      } else {
        if (!liked && data.message !== 'Already liked') {
          alert(data.message || 'Like failed');
        }
      }
    } catch (err) {
      console.error('Like/unlike request failed:', err.message);
      alert('Network error: ' + err.message);
    }
  };

  const handleLogin = (userData) => {
    setUser(userData);
    localStorage.setItem('forumUser', JSON.stringify(userData));
    if (userData.role === 'admin') {
      navigate('/admin');
    } else {
      navigate('/home');
    }
  };

  const handleLogout = () => {
    endAuthSession();
    localStorage.removeItem('forumUser');
    setUser(null);
    navigate('/');
  };

  // The API rejected our login token (expired, revoked, or missing) — sign out once.
  const userRef = useRef(user);
  userRef.current = user;
  useEffect(() => {
    const onExpired = () => {
      if (!userRef.current) return;
      clearAuthToken();
      localStorage.removeItem('forumUser');
      setUser(null);
      alert('Your session has expired. Please log in again.');
      navigate('/login');
    };
    window.addEventListener(AUTH_EXPIRED_EVENT, onExpired);
    return () => window.removeEventListener(AUTH_EXPIRED_EVENT, onExpired);
  }, [navigate]);

return (
  <div style={{ flex: 1 }}>
    {user ? <MessagingDock user={user} /> : null}
    <CoolAssistantWidget user={user} />
    <Routes>
      <Route
        path="/login"
        element={
          !user ? (
            <div>
              {/* 🔹 Header Section */}
              <header
                style={{
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  height: "50px",  width: "100%",
  padding: "8px 20px",

  /* ✅ Glassmorphism core */
  background: "rgba(255, 255, 255, 0.15)", // transparent white layer
  backdropFilter: "blur(12px) saturate(180%)",
  WebkitBackdropFilter: "blur(12px) saturate(180%)",

  /* ✅ Optional subtle gradient overlay */
  backgroundImage:
    "linear-gradient(to right, rgba(255, 255, 255, 0.15), rgba(173, 216, 230, 0.25))",

  /* ✅ Border + shadow for depth */
  border: "1px solid rgba(255, 255, 255, 0.3)",
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",

  position: "sticky",
  top: 0,
  zIndex: 1000,
  
}}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={Reallybot}
                    alt="Really Lesson Logo"
                    style={{ height: "30px", marginRight: "10px" }}
                  />
                
                </div>
              </header>

              {/* 🔹 Login Section */}
              <div style={styles.welcomeContainer}>
                <div style={styles.welcomeHeader}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                   
                  </div>
                  <h1 style={styles.welcomeTitle}>
                    Welcome to the Community of Online Learners
                  </h1>
                  <p style={styles.welcomeSubtitle}>
                    Connect. Share. Learn Together.
                  </p>
                </div>
                <div style={styles.loginSection}>
                  <Login onLogin={handleLogin} />
                </div>
              </div>
            </div>
          ) : (
            <Navigate to="/home" replace />
          )
        }
      />

<Route
  path="/groups/all-public"
  element={
    <>
      <Guestheader />
      <AllPublicGroupsPage />
    </>
  }
/>

<Route
  path="/groups/groupinpage"
  element={
    user ? (
      <GroupsHubPage
        user={user}
        onLogout={handleLogout}
      />
    ) : (
      <Navigate to="/login" replace />
    )
  }
/>

<Route path ="/groups/groupid" element ={<GroupDashboard  user={user} posts={posts}/>} />

    
  <Route
    path="/usermanagement"
    element={
      user ? (
        <UserManagementPage user={user} onLogout={handleLogout} />
      ) : (
        <Navigate to="/login" replace />
      )
    }
  />
  <Route
    path="/hiringmanagement"
    element={
      user?.role === 'admin' || user?.typeofuser === 'admin' ? (
        <HiringManagementPage user={user} onRefresh={refreshPosts} onLogout={handleLogout} />
      ) : (
        <Navigate to={user ? '/home' : '/login'} replace />
      )
    }
  />
  <Route
    path="/analytics"
    element={
      user?.role === 'admin' || user?.typeofuser === 'admin' ? (
        <Dashboard user={user} onLogout={handleLogout} />
      ) : (
        <Navigate to={user ? '/home' : '/login'} replace />
      )
    }
  />
  <Route
    path="/assistant"
    element={
      user?.role === 'admin' || user?.typeofuser === 'admin' ? (
        <AssistantCalibratePage user={user} onLogout={handleLogout} />
      ) : (
        <Navigate to={user ? '/home' : '/login'} replace />
      )
    }
  />
  {/* existing routes */}

<Route
  path="/news"
  element={<NewsListPage user={user} />}
/>
<Route
  path="/news/:id"
  element={<NewsDetails />}
/>

      <Route path="/survey/:surveyId" element={<SurveyStandalonePage user={user} onLogout={handleLogout} />} />
      <Route path="/hashtag/:tag" element={<HashtagPage user={user} onLogout={handleLogout} />} />
      <Route path="/hashtag" element={<HashtagPage user={user} onLogout={handleLogout} />} />

    {/* other routes */}


        <Route path="/events/:id" element={<EventDetails />} />
        <Route
          path="/events"
          element={
            user ? (
              <Evenlistall2
                user={user}
                onLogout={handleLogout}
                navigateToProfile={() => navigate('/profile')}
              />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route path="/events/guest" element={<EventDetailslist />} />

        <Route
          path="/event-attendance"
          element={
            user ? (
              <EventAttendanceList user={user} onLogout={handleLogout} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/event-attendance/:id"
          element={<EventAttendanceDetails user={user} onLogout={handleLogout} />}
        />

<Route
  path="/group/:groupId"
  element={
    user ? (
      <GroupPage
        user={user}
        posts={posts}
        onRefresh={refreshPosts}
        onLike={handleLike}
        likes={likes}
        userLiked={userLiked}
        onLogout={handleLogout}
        navigateToProfile={() => navigate('/profile')}
      />
    ) : (
      <Navigate to="/login" />
    )
  }
/>



<Route
  path="/guest/group/public/:groupId"
  element={
    <div>
      {/* 🔹 Header Section */}
      <header
        style={{
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  height: "60px",  width: "100%",
  padding: "8px 20px",

  /* ✅ Glassmorphism core */
  background: "rgba(255, 255, 255, 0.15)", // transparent white layer
  backdropFilter: "blur(12px) saturate(180%)",
  WebkitBackdropFilter: "blur(12px) saturate(180%)",

  /* ✅ Optional subtle gradient overlay */
  backgroundImage:
    "linear-gradient(to right, rgba(255, 255, 255, 0.15), rgba(173, 216, 230, 0.25))",

  /* ✅ Border + shadow for depth */
  border: "1px solid rgba(255, 255, 255, 0.3)",
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",

  position: "sticky",
  top: 0,
  zIndex: 1000,
 
}}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src={Reallybot}
            alt="Really Lesson Logo"
            style={{ height: "50px", marginRight: "10px" }}
          />
          <div style={{ fontSize: "24px", fontWeight: "bold" }}>
      
          </div>
        </div>
      </header>

      {/* 🔹 Page content */}
      <PublicGroupPageview2 />
    </div>
  }
/>





<Route path="/profile/:userId" element={<OnlineUser user={user} posts={posts} onLogout={handleLogout} />} />

<Route
  path="/network"
  element={
    user ? (
      <NetworkPage
        user={user}
        posts={posts}
        onRefresh={refreshPosts}
        onLike={handleLike}
        likes={likes}
        userLiked={userLiked}
        onLogout={handleLogout}
        navigateToProfile={() => navigate('/profile')}
      />
    ) : (
      <Navigate to="/login" replace />
    )
  }
/>

<Route
  path="/group/public/:groupId"
  element={
    user ? (
      <GroupPage
        user={user}
        posts={posts}
        onRefresh={refreshPosts}
        onLike={handleLike}
        likes={likes}
        userLiked={userLiked}
        onLogout={handleLogout}
        navigateToProfile={() => navigate('/profile')}
      />
    ) : (
      <Navigate to="/login" replace />
    )
  }
/>




  <Route
    path="/home"
    element={
      user ? (
        <UserHome
          user={user}
          posts={posts}
          onRefresh={refreshHomeFeed}
          onLoadMore={loadMorePosts}
          feedHasMore={feedHasMore}
          feedLoading={feedLoading}
          pendingNewCount={pendingNewCount}
          onShowNewPosts={applyPendingNewPosts}
          onLike={handleLike}
          likes={likes}
          userLiked={userLiked}
          onLogout={handleLogout}
          navigateToProfile={() => navigate('/profile')}
          feedFilter={feedFilter}
          onFeedFilterChange={handleFeedFilterChange}
        />
      ) : (
        <Navigate to="/login" replace />
      )
    }
  />

  {/* ✅ Add Post Detail Route */}
   <Route
  path="/home/post/:id"
  element={
    user ? (
      <div>
        {/* 🔹 Header Section */}
        <AuthenticatedNavbar user={user} onLogout={handleLogout} />

        {/* 🔹 Post detail content */}
        <PostDetail
          user={user}
          posts={posts}
          onRefresh={refreshHomeFeed}
          onLike={handleLike}
          likes={likes}
          userLiked={userLiked}
          onLogout={handleLogout}
          navigateToProfile={() => navigate('/profile')}
        />
      </div>
    ) : (
      <Navigate to="/login" replace />
    )
  }
/>

  <Route
    path="/home/article/:id"
    element={
      user ? (
        <div>
          <AuthenticatedNavbar user={user} onLogout={handleLogout} />
          <ArticleDetail user={user} posts={posts} />
        </div>
      ) : (
        <Navigate to="/login" replace />
      )
    }
  />

  <Route
    path="/home/blog/:id"
    element={
      user ? (
        <div>
          <AuthenticatedNavbar user={user} onLogout={handleLogout} />
          <BlogDetail user={user} posts={posts} />
        </div>
      ) : (
        <Navigate to="/login" replace />
      )
    }
  />

  <Route
    path="/blogs"
    element={
      <div>
        {user ? (
          <AuthenticatedNavbar user={user} onLogout={handleLogout} />
        ) : (
          <Guestheader />
        )}
        <BlogBoard user={user} onRefresh={refreshHomeFeed} />
      </div>
    }
  />

  <Route
    path="/learning"
    element={
      <div>
        {user ? (
          <AuthenticatedNavbar user={user} onLogout={handleLogout} />
        ) : (
          <Guestheader />
        )}
        <LearningQABoard user={user} onRefresh={refreshHomeFeed} />
      </div>
    }
  />

  <Route
    path="/home/question/:id"
    element={
      user ? (
        <div>
          <AuthenticatedNavbar user={user} onLogout={handleLogout} />
          <PostDetail user={user} posts={posts} />
        </div>
      ) : (
        <Navigate to="/login" replace />
      )
    }
  />

  <Route
    path="/home/hiring/:id"
    element={
      user ? (
        <div>
          <AuthenticatedNavbar user={user} onLogout={handleLogout} />
          <HiringDetail user={user} posts={posts} />
        </div>
      ) : (
        <Navigate to="/login" replace />
      )
    }
  />

  <Route
    path="/home/looking-for-job/:id"
    element={
      user ? (
        <div>
          <AuthenticatedNavbar user={user} onLogout={handleLogout} />
          <LookingForJobDetail user={user} posts={posts} />
        </div>
      ) : (
        <Navigate to="/login" replace />
      )
    }
  />

  <Route
    path="/looking-for-job"
    element={
      user ? (
        <div>
          <AuthenticatedNavbar user={user} onLogout={handleLogout} />
          <LookingForJobBoard user={user} />
        </div>
      ) : (
        <Navigate to="/login" replace />
      )
    }
  />

  <Route
    path="/hiring/applications"
    element={
      user ? (
        <div>
          <AuthenticatedNavbar user={user} onLogout={handleLogout} />
          <EmployerApplications user={user} />
        </div>
      ) : (
        <Navigate to="/login" replace />
      )
    }
  />

  <Route
    path="/my-applications"
    element={
      user ? (
        <div>
          <AuthenticatedNavbar user={user} onLogout={handleLogout} />
          <MyApplications user={user} />
        </div>
      ) : (
        <Navigate to="/login" replace />
      )
    }
  />

  <Route
    path="/saved"
    element={
      user ? (
        <div>
          <AuthenticatedNavbar user={user} onLogout={handleLogout} />
          <SavedPage user={user} />
        </div>
      ) : (
        <Navigate to="/login" replace />
      )
    }
  />

  <Route
    path="/my-learning"
    element={
      user ? (
        <div>
          <AuthenticatedNavbar user={user} onLogout={handleLogout} />
          <MyLearningDashboard user={user} />
        </div>
      ) : (
        <Navigate to="/login" replace />
      )
    }
  />

  <Route
    path="/profile-views"
    element={
      user ? (
        <div>
          <AuthenticatedNavbar user={user} onLogout={handleLogout} />
          <ProfileViewsInbox user={user} />
        </div>
      ) : (
        <Navigate to="/login" replace />
      )
    }
  />

<Route
    path="/home/post/:id"
    element={
      user ? (
        <PostDetail
          user={user}
          posts={posts}
          onRefresh={refreshHomeFeed}
          onLike={handleLike}
          likes={likes}
          userLiked={userLiked}
          onLogout={handleLogout}
          navigateToProfile={() => navigate('/profile')}
        />
      ) : (
        <Navigate to="/login" replace />
      )
    }
  />


<Route
  path="/home/public/:id"
  element={
    <div>
      {/* 🔹 Header Section */}
      <header
        style={{
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  height: "60px",  width: "100%",
  padding: "8px 20px",

  /* ✅ Glassmorphism core */
  background: "rgba(255, 255, 255, 0.15)", // transparent white layer
  backdropFilter: "blur(12px) saturate(180%)",
  WebkitBackdropFilter: "blur(12px) saturate(180%)",

  /* ✅ Optional subtle gradient overlay */
  backgroundImage:
    "linear-gradient(to right, rgba(255, 255, 255, 0.15), rgba(173, 216, 230, 0.25))",

  /* ✅ Border + shadow for depth */
  border: "1px solid rgba(255, 255, 255, 0.3)",
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",

  position: "sticky",
  top: 0,
  zIndex: 1000,
  
}}
      >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <img
            src={Reallybot}
            alt="Really Lesson Logo"
            style={{ height: '50px', marginRight: '10px' }}
          />
     
        </div>
      </header>

      {/* 🔹 Public post detail content */}
      <PublicPostDetail
        user={user}
        posts={posts}
        onRefresh={refreshPosts}
        onLike={handleLike}
        likes={likes}
        userLiked={userLiked}
        onLogout={handleLogout}
      />
    </div>
  }
/>










     

      <Route
        path="/admin"
        element={
          isAdmin(user) ? (
            <AdminPanel
              user={user}
              posts={posts}
              onRefresh={refreshPosts}
              onLike={handleLike}
              likes={likes}
              userLiked={userLiked}
              onLogout={handleLogout}
              navigateToProfile={() => navigate('/profile')}
            />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route
        path="/admin/reports"
        element={
          isAdmin(user) ? (
            <AdminPanel
              user={user}
              posts={posts}
              onRefresh={refreshPosts}
              onLike={handleLike}
              likes={likes}
              userLiked={userLiked}
              onLogout={handleLogout}
            />
          ) : (
            <Navigate to={user ? '/home' : '/login'} replace />
          )
        }
      />
      <Route
        path="/admin/groups"
        element={
          isAdmin(user) ? (
            <GroupsManagementPage user={user} onLogout={handleLogout} />
          ) : (
            <Navigate to={user ? '/home' : '/login'} replace />
          )
        }
      />

     <Route
  path="/"
  element={
    user ? (
      <Navigate to="/home" replace />
      
    ) : (
  
      <div style={{ }}>
       {/*     <Guestheader   style={{ 
      
  }}/>  */}

 
   <div><PostlistGuest /></div>  
      </div>   
      
    )
  }
/>

      <Route
        path="/profile"
        element={
          user ? (
            <ProfilePage
              user={user}
              onLogout={handleLogout}
              navigateToHome={() => navigate('/home')}
              onRefresh={refreshPosts}
            />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />

<Route
  path="/aboutus"
  element={
    user ? (
      <Aboutcool
        user={user}
        onLogout={handleLogout}
        navigateToHome={() => navigate('/home')}
       navigateToProfile={() => navigate('/profile')}
        onRefresh={refreshPosts}
      />
    ) : (
      <Navigate to="/login" replace />
    )
  }
/>  {/* âœ… self-closing tag */}

      <Route
        path="/register"
        element={<Register />}
      />

      <Route
        path="/home"
        element={
          user ? (
            <UserHome
              user={user}
              posts={posts}
              onRefresh={refreshHomeFeed}
              onLoadMore={loadMorePosts}
              feedHasMore={feedHasMore}
              feedLoading={feedLoading}
              pendingNewCount={pendingNewCount}
              onShowNewPosts={applyPendingNewPosts}
              onLike={handleLike}
              likes={likes}
              userLiked={userLiked}
              onLogout={handleLogout}
              navigateToProfile={() => navigate('/profile')}
              feedFilter={feedFilter}
              onFeedFilterChange={handleFeedFilterChange}
            />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />


     <Route
  path="/myprofileinfo"
  element={
     user?(
      <MyProfilePage
        user={user}
        posts={posts}
        onRefresh={refreshPosts}
        onLike={handleLike}
        likes={likes}
        userLiked={userLiked}
        onLogout={handleLogout}
        navigateToProfile={() => navigate('/profile')}
      />
    ) : (
      <Navigate to="/login" replace />  // âœ… Proper fallback
    )
  }
/>

    </Routes>
  </div>
);


}

function Evenlistall2({
  user = {},
  onLogout,
}) {
  return (
    <div style={{ width: "100%", margin: 0, padding: 0 }}>
      <AuthenticatedNavbar user={user} onLogout={onLogout} />
      <section style={{ padding: "20px" }}>
        <Evenlistalls user={user} />
      </section>
    </div>
  );
}





function Aboutcool({ user, onLogout }) {
  return (
    <div style={{ width: '100%', margin: 0, padding: 0 }}>
      <AuthenticatedNavbar user={user} onLogout={onLogout} />
      <section style={{ padding: '20px' }}>
        <About/>
      </section>
    </div>
  );
}







function MyProfilePage({ user, onLogout }) {
  return (
    <div style={{ width: '100%', margin: 0, padding: 0 }}>
      <AuthenticatedNavbar user={user} onLogout={onLogout} />
      <section style={{ padding: 0 }}>
        <MyProfilePages onLogout={onLogout} />
      </section>
    </div>
  );
}


function NetworkPage({ user, onLogout }) {
  return (
    <div style={{ width: '100%', margin: 0, padding: 0 }}>
      <AuthenticatedNavbar user={user} onLogout={onLogout} />
      <section style={{ padding: '0' }}>
        <MyNetwork user={user} />
      </section>
    </div>
  );
}


function UserHome({
  user,
  posts,
  onRefresh,
  onLoadMore,
  feedHasMore = false,
  feedLoading = false,
  pendingNewCount = 0,
  onShowNewPosts,
  onLike,
  likes,
  userLiked,
  onLogout,
  feedFilter = 'all',
  onFeedFilterChange,
}) {
  return (
    <div style={{ width: '100%', margin: 0, padding: 0, background: '#f1f5f9', minHeight: '100vh' }}>
      <AuthenticatedNavbar user={user} onLogout={onLogout} />

      <section style={styles.postFormSection}>
      </section>

      <section style={styles.postListSection}>
        <HomeUser
          posts={posts}
          user={user}
          likes={likes}
          userLiked={userLiked}
          onLike={onLike}
          onRefresh={onRefresh}
          onLoadMore={onLoadMore}
          feedHasMore={feedHasMore}
          feedLoading={feedLoading}
          pendingNewCount={pendingNewCount}
          onShowNewPosts={onShowNewPosts}
          feedFilter={feedFilter}
          onFeedFilterChange={onFeedFilterChange}
        />
      </section>
    </div>
  );
}



function GroupPage({ user, posts, onLogout }) {
  const { groupId } = useParams();

  return (
    <div style={{ width: "100%", margin: 0, padding: 0, fontFamily: "Segoe UI, sans-serif" }}>
      <AuthenticatedNavbar user={user} onLogout={onLogout} />
      <section style={{ padding: "20px" }}>
        <GroupDashboard groupId={groupId} user={user} posts={posts} />
      </section>
    </div>
  );
}


function OnlineUser({ user, posts, onLogout }) {
  const { userId } = useParams();

  return (
    <div style={{ width: "100%", margin: 0, padding: 0, fontFamily: "Segoe UI, sans-serif" }}>
      {user ? <AuthenticatedNavbar user={user} onLogout={onLogout} /> : null}
      <section style={{ padding: "20px" }}>
        <UserProfile userId={userId || user?.id} user={user} posts={posts} />
      </section>
    </div>
  );
}




function AdminPanel({
  user,
  posts,
  onRefresh,
  onLike,
  likes,
  userLiked,
  onLogout,
}) {
  const navigate = useNavigate();
  const location = useLocation();

  const navLinks = [
    { label: 'Posts', target: '/admin' },
    { label: 'Reports', target: '/admin/reports' },
    { label: 'Groups', target: '/admin/groups' },
    { label: 'Hiring', target: '/hiringmanagement' },
    { label: 'Analytics', target: '/analytics' },
    { label: 'Assistant', target: '/assistant' },
  ];

  const navButtonStyle = {
    borderRadius: '999px',
    padding: '8px 18px',
    border: '1px solid #cbd5f5',
    backgroundColor: '#fff',
    color: '#1b2650',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'background 0.2s ease, color 0.2s ease',
  };

  const navButtonActiveStyle = {
    backgroundColor: '#1d4ed8',
    color: '#fff',
    borderColor: '#1d4ed8',
  };

  return (
    <div style={{ width: "100%", margin: 0, padding: 0 }}>
      <AuthenticatedNavbar user={user} onLogout={onLogout} />

      <div
        style={{
          padding: '10px 20px',
          backgroundColor: '#eef2ff',
          display: 'flex',
          gap: '10px',
          flexWrap: 'wrap',
        }}
      >
        {navLinks.map((link) => {
          const isActive = location.pathname === link.target;
          return (
            <button
              type="button"
              key={link.target}
              onClick={() => navigate(link.target)}
              style={{
                ...navButtonStyle,
                ...(isActive ? navButtonActiveStyle : {}),
              }}
            >
              {link.label}
            </button>
          );
        })}
      </div>

      <main style={{ padding: "0px" }}>
        <section style={{ marginBottom: "10px" }}>
        </section>

        <section>
          {location.pathname === '/admin/reports' ? (
            <ReportsQueue user={user} />
          ) : (
            <PostListAdmin
              posts={posts}
              user={user}
              likes={likes}
              userLiked={userLiked}
              onLike={onLike}
              onRefresh={onRefresh}
            />
          )}
        </section>
      </main>
    </div>
  );
}


function ProfilePage({ user, onLogout, onRefresh }) {
  return (
    <div style={{ width: '100%', margin: 0, padding: 0 }}>
      <AuthenticatedNavbar user={user} onLogout={onLogout} />
      <section style={styles.profileSection}>
        <ProfilePost user={user} onRefresh={onRefresh} />
      </section>
    </div>
  );
}








const styles = {
  welcomeContainer: {
    textAlign: 'center',
    padding: '20px 1px',
    backgroundColor: 'white',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  welcomeHeader: {
    marginBottom: 1,
  },
  logoLarge: {
    height: 40,
    marginBottom: 1,
  },
  welcomeTitle: {
    fontSize: '20px',
    color: '#0077b6',
    margin: 0,
  },
  welcomeSubtitle: {
    fontSize: '15px',
    color: '#555',
  },
  loginSection: {
    width: '50%',
    maxWidth: 500,
  },
  container: {
    maxWidth: '100%',
    margin: '20px auto',
    

  },
  header: {
  maxWidth:'100%',                // Full viewport width
          // Sticks to the top
  top: 0,
  left: 0,
  zIndex: 1000,                  // Ensures it's on top
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '10px 15px',
  backgroundColor: 'lightblue', // Header background color
  width: '100%',                // Full width
         // Fixed position
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', // Optional shadow
},
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  logoSmall: {
    height: 30,
  },
  rightHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  username: {
    color: '#0077b6',
    fontWeight: 700,
    fontSize: '1.1rem',
    display: 'flex',
    alignItems: 'center',
  },
  iconButton: {
    backgroundColor: '#0077b6',
    color: '#fff',
    border: 'none',
    padding: '6px 10px',
    borderRadius: 4,
    cursor: 'pointer',
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
    transition: 'background-color 0.3s',
  },
  postFormSection: {},
  postListSection: {},
  profileSection: {
    marginTop: 20,
  },
  adminContainer: {
    display: 'flex',
    minHeight: '50vh',
  },
  adminMain: {
    maxWidth: '100%',
    flex: 1,
    padding: '20px 30px',
  },
};

export default AppWrapper;
